// extracted by mini-css-extract-plugin
export var chain = "chains-module--chain--2i9bO";
export var flex = "chains-module--flex--2HlAS";
export var fixMain = "chains-module--fixMain--ODldt";
export var stretch = "chains-module--stretch--3vmRY";
export var contentParent = "chains-module--contentParent--2Nm2e";
export var imgParent = "chains-module--imgParent--3vtYe";
export var header = "chains-module--header--7zGfm";
export var btn = "chains-module--btn--34dvV";
export var dots = "chains-module--dots--3PVMr";